import React, { useContext } from 'react';
import { TextField } from '@material-ui/core';

import { FormContext } from './FormContext';
import { useFormField, type IFormFieldProps } from './useFormField';

interface IFormInputProps extends IFormFieldProps<string> {
    customRef?: React.Ref<HTMLDivElement>;
    callbackOnBlur?: (value?: string) => void;
    type?: string;
}

export const FormInput: React.FC<IFormInputProps> = (props) => {
    const {
        name,
        title,
        validators,
        customRef,
        callbackOnBlur,
        type,
        value: _value,
        ...rest
    } = props;

    const { handleChange, hasError, getHelperText, formValue } =
        useFormField<string>(props);

    const context = useContext(FormContext);

    return (
        <TextField
            {...rest}
            inputRef={customRef}
            type={type}
            id={name}
            name={name}
            label={title}
            value={formValue}
            error={hasError()}
            onChange={handleChange(name, validators)}
            onBlur={(e) => {
                handleChange(name, validators);
                if (callbackOnBlur) {
                    callbackOnBlur(e.target.value);
                }
            }}
            margin="normal"
            helperText={getHelperText()}
            disabled={context.formDisabled}
            InputProps={{
                className: 'Form__Field Form__Input',
            }}
        />
    );
};
